import React, { useState, useEffect } from 'react';
import {
  IonContent, IonHeader, IonPage, IonRadio, IonRadioGroup, IonList, IonItem,
  IonLabel, IonTitle, IonToolbar, IonImg, IonLoading,
  IonButton
} from '@ionic/react';
import { Input } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { UNIFORM_RESOURCE_LOCATORS, colorTheme } from '../../utils/constants';
import { fetchSurveyStatus, updateSurvey, showLoading } from '../../redux/actions';
import { Container } from 'reactstrap';
import _ from 'lodash';

const mapStateToProps = state => ({
  survey: state.survey
});

const mapDispatchToProps = dispatch => ({
  fetchSurveyStatus: () => dispatch(fetchSurveyStatus()),
  updateSurvey: (payload) => dispatch(updateSurvey(payload))
});

const NewUserSurvey = ({ survey, fetchSurveyStatus, updateSurvey, history }) => {
  const [responses, setResponses] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [surveyQuestions, setSurveyQuestions] = useState([]);
  const [showIonloader, setShowIonloader] = useState(false);

  useEffect(() => {
    const initializeSurvey = async () => {
      if (_.isEmpty(survey)) {
        showLoading(true);
        await fetchSurveyStatus();
        showLoading(false);
      } else {
        if (survey.isSurveyCompleted) {
          history.push(UNIFORM_RESOURCE_LOCATORS.dashboard);
        }

        if (survey.surveyQuestions) {
          const parsedQuestions = survey.surveyQuestions.map(question => JSON.parse(question));
          setSurveyQuestions(parsedQuestions);
        }
      }
    };

    initializeSurvey();
  }, [survey]);

  const handleResponseChange = (questionId, value) => {
    setResponses(prevResponses => ({ ...prevResponses, [questionId]: value }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < surveyQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const handleSubmit = async () => {
    setShowIonloader(true);
    try {
      await updateSurvey(responses);
      history.push(UNIFORM_RESOURCE_LOCATORS.dashboard);
    } catch (error) {
      console.error('Error updating survey:', error);
      setCurrentQuestionIndex(0);
    } finally {
      setShowIonloader(false);
    }
  };

  const currentQuestion = surveyQuestions[currentQuestionIndex];
  const isLastQuestion = currentQuestionIndex === surveyQuestions.length - 1;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle style={{ textAlign: 'center' }}>Bomahut Survey</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
      <IonLoading className="custom-loading" isOpen={showIonloader} message="Loading ..." />
        <Container style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '2em' }}>
            <IonImg
              slot="start"
              src="images/logos/BOMAHUT-purple.svg"
              style={{ maxWidth: '200px', maxHeight: '75px', textAlign: 'center' }}
              alt="Bomahut Logo"
              className="ion-margin"
            />
          </div>
          <h5>Bomahut helps you make more rental profits with less management stress.</h5>
          {currentQuestion && (
            <div className="my-2" style={{ width: "100%" }}>
              <h5 className='my-2'>{currentQuestion.question}</h5>
              {currentQuestion.answer_type === 'radio' ? (
                <IonRadioGroup value={responses[currentQuestion.question_id]} onIonChange={e => handleResponseChange(currentQuestion.question_id, e.detail.value)}>
                  <IonList>
                    {currentQuestion.options.map(option => (
                      <IonItem key={option}>
                        <IonLabel>{option.charAt(0).toUpperCase() + option.slice(1)}</IonLabel>
                        <IonRadio slot="start" value={option} />
                      </IonItem>
                    ))}
                  </IonList>
                </IonRadioGroup>
              ) : (
                <div style={{ minWidth: '240px' }}>
                  <Input
                    type='number'
                    min='0'
                    value={responses[currentQuestion.question_id] || ''}
                    onChange={(e)=> setResponses(prev => ({...prev, [currentQuestion.question_id]: e.target.value}))}
                    className='bg-white'
                    placeholder='e.g. 15'
                  />
                </div>
              )}
              <IonButton
                expand='full'
                className="mt-3"
                onClick={isLastQuestion ? handleSubmit : handleNext}
                disabled={responses[currentQuestion.question_id] === undefined || responses[currentQuestion.question_id] === ''}
                style={{ backgroundColor: colorTheme["primary"]["700"], width: "100%" }}
              >
                {isLastQuestion ? 'Submit' : 'Next'}
              </IonButton>
            </div>
          )}
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUserSurvey));
